import React from 'react';
import c from '../w.js';

const IconGbp = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M16.5463 19V17.0121H10.5826C10.9917 16.5327 11.1451 15.9254 11.1131 15.1775L11.062 13.8288H13.9384V11.892H10.9917L10.9086 9.69956C10.9022 8.31888 11.7395 7.67968 12.6855 7.67968C13.6124 7.67968 14.4625 8.19743 14.3794 9.36078L16.5975 9.54615C16.8276 7.43039 15.2168 5.7301 12.628 5.7301C10.3716 5.7301 8.49876 7.10439 8.59464 9.69956L8.67134 11.892H7.27148V13.8288H8.73526L8.7864 15.2798C8.80558 15.9829 8.67134 16.929 8.03853 17.0121H7.31623V19H16.5463Z" })
  )
);

export { IconGbp };
